<div class="container">

    <div class="title">
        <h1 *ngIf="!isShowPassword">¡Hola, {{userForm.get('fullName')?.value}}!</h1>
        <div class="bar-user" *ngIf="isShowPassword">
            <p class="me-data" (click)="isShowPassword = false">Mis datos</p>
            <img src="../../assets/icon/chevron-right.svg" alt="icon arrow right">
            <p class="me-password"> Contraseña </p>
        </div>
    </div>

    <div class="container-form">
        <form [formGroup]="userForm" (ngSubmit)="onSubmitUser()">
            <div class="profile-form" *ngIf="!isShowPassword">
                <h2 class="form-title">Mis datos</h2>

                <div class="form-row">
                    <div class="form-group">
                        <label for="email">E-mail</label>
                        <input type="email" id="email" class="disabled-input-value" disabled placeholder="{{userForm.get('email')?.value}}">
                    </div>

                    <div class="form-group">
                        <label for="password">Contraseña</label>
                        <div class="password-field">
                            <input type="text" id="password" value="********" disabled>
                            <div class="container-button">
                                <button type="button" class="change-password"
                                    (click)="showPassword()">Modificar contraseña</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label for="fullName">Nombre y apellido</label>
                        <div [class.touched]="userForm.get('fullName')?.touched">
                            <input 
                                type="text" 
                                id="fullName" 
                                formControlName="fullName"  
                                (focus)="userForm.get('fullName')?.markAsTouched()"
                            >
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="document">Número de documento</label>
                        <input type="text" id="document" disabled  class="disabled-input-value" placeholder="{{userForm.get('document')?.value}}">
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label for="birthDate">Fecha de nacimiento</label>
                        <div [class.touched]="userForm.get('birthDate')?.touched">
                            <input type="date" id="birthDate" formControlName="birthDate" (focus)="userForm.get('birthDate')?.markAsTouched()">
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="phone">Teléfono</label>
                        <div class="phone-fields">
                            <div class="phone-code-container{{userForm.get('phoneCode')?.invalid ? '-invalid' : ''}}">
                                <input 
                                    type="number" 
                                    class="phone-code"
                                    formControlName="phoneCode{{userForm.get('phoneCode')?.invalid ? '-invalid' : ''}}" 

                                    maxlength="2"
                                    [class.invalid]="userForm.get('phoneCode')?.invalid"
                                >
                            </div>

                            <div class="phone-number-container-{{userForm.get('phoneNumber')?.invalid ? 'invalid' : 'valid'}}">
                                <input 
                                    type="number" 
                                    class="phone-number" 
                                    formControlName="phoneNumber" 
                                    maxlength="10"
                                    [class.invalid]="userForm.get('phoneNumber')?.invalid"
                                >
                            </div>
                            
                            
                        </div>
                        <div class="show-phone" *ngIf="userForm.get('phoneNumber')?.invalid || userForm.get('phoneCode')?.invalid">
                            El teléfono que ingresaste no es válido.
                        </div>
                    </div>
                </div>

                <div class="form-actions">
                    <button type="submit" class="save-button{{(userForm.invalid || isInitialLoad)  ? '-disabled' : ''}}" [disabled]="userForm.invalid || isEditing">Guardar cambios</button>
                </div>
            </div>
        </form>


            <div class="profile-form-password" *ngIf="isShowPassword">
                <form [formGroup]="passwordForm" (ngSubmit)="onSubmitPassword()">
                    <div class="profile-form">
                        <h2 class="form-title">Contraseña</h2>


                        <div class="form-group">
                            <label for="email">Contraseña actual</label>
                            <div class="password-field{{(isCurrentPasswordValid || (passwordForm.get('currentPassword')?.invalid) && passwordForm.get('currentPassword')?.touched) ? '-invalid' : ''}}">                               
                                <input 
                                    [type]="!showPassword1 ? 'password' : 'text'" 
                                    id="email" 
                                    formControlName="currentPassword"
                                    placeholder="Ingresá la contraseña actual"
                                >
                                
                                <span 
                                class="eye" [ngClass]="showPassword1 ? 'show' : ''" 
                                (click)="showPassword1 = !showPassword1">
                            </span>
                            
                        </div>
                        
                        <p *ngIf="isCurrentPasswordValid" class="error-message">La contraseña actual no es la correcta</p>
                            
                            <div class="container-button">
                                <button type="button" class="change-password" (click)="showModalRecupero()" [disabled]="isSendRecuperation">¿Olvidaste tu contraseña?</button>
                            </div>
                            
                        </div>

                        <div class="form-group">
                            <label for="email">Nueva contraseña</label>
                            <div class="password-field{{(!isPasswordValid && passwordForm.get('newPassword')?.touched) && 'invalid' || (!passwordsMatch && passwordForm.get('newPassword')?.touched) ? '-invalid' : ''}}">
                                <input 
                                    [type]="!showPassword2 ? 'password' : 'text'" 
                                    id="email" 
                                    formControlName="newPassword"
                                    placeholder="Nueva contraseña"
                                >
                                <span 
                                    class="eye" [ngClass]="showPassword2 ? 'show' : ''" 
                                    (click)="showPassword2 = !showPassword2">
                                </span>
                            </div>
                            <div class="verification-password">
                                <p class="verification-title">Debe contener:</p>
                                <div class="verification-rules">
                                    <div class="rule-item">
                                        <div class="icon-check{{passwordValidations.hasUpperCase ? '-validUpperCase' : ''}}">
                                            <img src="../../assets/icon/icon-check-white.svg" alt="icon check white">
                                        </div>
                                        <span>1 mayúscula</span>
                                    </div>
                                    <div class="rule-item">
                                        <div class="icon-check{{passwordValidations.hasNumber ? '-validNumber' : ''}}">
                                            <img src="../../assets/icon/icon-check-white.svg" alt="icon check white">
                                        </div>
                                        <span>1 número</span>
                                    </div>
                                    <div class="rule-item">
                                        <div class="icon-check{{passwordValidations.hasMinLength ? '-validMinLength' : ''}}">
                                            <img src="../../assets/icon/icon-check-white.svg" alt="icon check white">
                                        </div>
                                        <span>8 caracteres mínimo</span>
                                    </div>
                                    <div class="rule-item">
                                        <div class="icon-check{{passwordValidations.hasLowerCase ? '-validLowerCase' : ''}}">
                                            <img src="../../assets/icon/icon-check-white.svg" alt="icon check white">
                                        </div>
                                        <span>1 minúscula</span>
                                    </div>
                                    <div class="rule-item">
                                        <div class="icon-check{{passwordValidations.hasSpecialChar ? '-validSpecialChar' : ''}}">
                                            <img src="../../assets/icon/icon-check-white.svg" alt="icon check white">
                                        </div>
                                        <span>1 signo</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="email">Repetí la contraseña</label>
                            <div class="password-field{{(!passwordsMatch && passwordForm.get('confirmPassword')?.touched) ? '-invalid' : ''}}">
                                <input 
                                    [type]="!showPassword3 ? 'password' : 'text'" 
                                    id="email"
                                    formControlName="confirmPassword"
                                    (paste)="$event.preventDefault()"
                                    (copy)="$event.preventDefault()"
                                    (cut)="$event.preventDefault()"
                                    placeholder="Repetí la contraseña"
                                >
                                <span 
                                    class="eye" 
                                    [ngClass]="showPassword3 ? 'show' : ''" 
                                    (click)="showPassword3 = !showPassword3">
                                </span>
                            
                            </div>
                            <div *ngIf="passwordForm?.get('confirmPassword')?.touched && !passwordsMatch" 
                                class="error-message">
                                Las contraseñas no coinciden. Revisalas e intentá de nuevo.
                            </div>
                        </div>

                        <div class="form-actions">
                            <button type="submit" class="save-button{{passwordForm.invalid ? '-disabled' : ''}}" [disabled]="passwordForm.invalid || isEditing">Cambiar contraseña</button>
                        </div>
                    </div>

                </form>
            </div>
    </div>



    <div class="change-password-success" *ngIf="ChangePasswordSuccess">
        <div class="container-img">
            <img src="../../assets/images/chek-modal-user.svg" alt="icon check">
        </div>
        <p>Cambiaste tu contraseña</p>
    </div>



</div>

<div class="modal-recupero-user" *ngIf="isVisibleModalRecupero">
    <div class="login-container">
        <button type="button" class="login-close" aria-label="Close" (click)="closeLogin()">
            <img src="../../../../assets/images/register-asset/close.svg" alt="icon close">
        </button>

        <div class="login-header">
            <div class="login-img">
                <img class="login-img" src="../../../../assets/images/logo-header-shell.svg" alt="">
            </div>
            <div class="login-title">
                <h4>¿Olvidaste tu contraseña?</h4>
            </div>
        </div>

        <div class="login-form">
            <p>Te hemos enviado un correo para continuar con el proceso de recupero de contraseña</p>
            <button type="button" aria-label="Close" (click)="closeLogin()">
                Volver
            </button>
        </div>
    </div>
</div>